import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import AboutView from '../views/AboutView.vue';
import ConfirmView from '../views/ConfirmView.vue';
import TrailView from '../views/TrailView.vue';
import TrailIntroductionView from '../views/TrailIntroductionView.vue';
import TrailDescriptionView from '../views/TrailDescriptionView.vue';
import TrailGpsView from '../views/TrailGpsView.vue';
import TrailReactionView from '../views/TrailReactionView.vue';

/*
Nested Routes
/routes/trailid/introductie           /routes/trailid/beschrijving
+------------------+                  +-----------------+
| routes           |                  | routes          |
| +--------------+ |                  | +-------------+ |
| | introductie  | |  +------------>  | | beschrijving| |
| |              | |                  | |             | |
| +--------------+ |                  | +-------------+ |
+------------------+                  +-----------------+
*/

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView,
  },
  {
    path: '/bevestig',
    name: 'Confirm',
    component: ConfirmView,
  },
  {
    path: '/routes/:trailid?/:slug?',
    component: TrailView,
    props: true,
    children: [
      {
        path: '',
        name: 'Trail',
        component: TrailIntroductionView,
        props: true,
      },
      {
        path: 'introductie',
        name: 'TrailIntroduction',
        component: TrailIntroductionView,
        props: true,
      },
      {
        path: 'beschrijving',
        name: 'TrailDescription',
        component: TrailDescriptionView,
        props: true,
      },
      {
        path: 'gpsinformatie',
        name: 'TrailGps',
        component: TrailGpsView,
        props: true,
      },
      {
        path: 'reactie',
        name: 'TrailReaction',
        component: TrailReactionView,
        props: true,
      },

    ],
  },
  // {
  //   path: '/routeselectie/:trailpackagename?/:trailid?/:slug?/introductie',
  //   name: 'route introductie',
  //   component: RouteIntroductieView,
  //   props: true,
  // },
  // {
  //   path: '/routeselectie/:trailpackagename?/:trailid?/:slug?/beschrijving',
  //   name: 'route beschrijving',
  //   component: RouteBeschrijvingView,
  //   props: true,
  // },
  // {
  //   path: '/routeselectie/:trailpackagename?/:trailid?/:slug?',
  //   name: 'route introductie',
  //   component: RouteIntroductieView,
  //   props: true,
  // },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
